import React, { useEffect } from 'react';
import { Box } from 'rebass/styled-components';
import PropTypes from 'prop-types';

const MEETINGS_URLS = Object.freeze({
  contacts: 'https://meetings.hubspot.com/mitch278/getroconnect-meeting-link?embed=true',
  companies: 'https://meetings.hubspot.com/laura-marks?embed=true',
});

export const HubspotEmbed = ({ type }) => {
  useEffect(() => {
    const script = document.createElement('script');
    const body = document.getElementsByTagName('body')[0];

    script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
    body.appendChild(script);

    return () => {
      body.removeChild(script);
    };
  }, []);

  const url = MEETINGS_URLS[type] ?? MEETINGS_URLS.contacts;

  return <Box className="meetings-iframe-container" data-src={url} />;
};

HubspotEmbed.propTypes = {
  type: PropTypes.string,
};

HubspotEmbed.defaultProps = {
  type: 'contacts',
};
